// ONE AREA'S SHOP DRAWINGS, ON THE LEVELS & AREAS PAGE.
//
// Owner, 2026-10-13: "fix the shop drawings to reflect areas and shop drawings
// activities from the schedule, in the area/levels ... show full path like we
// do on digest so user can understand which activity parent he is working in."
//
// The drawings are the ones STAMPED with this area from their schedule
// activity (back/utils/shopDrawingPlace - the activity's place in the tree,
// then the area tagging), asked for by the zone's id because an area's name
// repeats across levels. Each row shows its activity's full path, so a drawing
// for "Level 1 / L1 · Area A" and one for "Level 2 / L2 · Area A" read apart.
//
// SAID, NOT SWALLOWED: a failed read says so rather than reading as an area
// with no drawings.
import React, { useEffect, useState } from "react";
import { Tag, Spin } from "antd";
import { getShopDrawings } from "api/tracking/shopDrawingsApi";
import ActivityPathLine from "./ActivityPathLine";

const STATUS = {
  requested: ["Requested", "red"],
  submitted: ["Delivered", "gold"],
  under_review: ["Waiting for approval", "gold"],
  approved: ["Released", "green"],
  rejected: ["Returned", "red"],
};

export default function AreaShopDrawings({ projectId, areaId, areaName = "" }) {
  const [state, setState] = useState({ loading: true, rows: [], error: "" });

  useEffect(() => {
    if (!projectId || !areaId) return undefined;
    let alive = true;
    setState({ loading: true, rows: [], error: "" });
    getShopDrawings(projectId, { filters: 1, areaId })
      .then((r) => { if (alive) setState({ loading: false, rows: (r && r.drawings) || [], error: "" }); })
      .catch((e) => { if (alive) setState({ loading: false, rows: [], error: (e && e.message) || "error" }); });
    return () => { alive = false; };
  }, [projectId, areaId]);

  return (
    <div data-testid="area-shop-drawings" style={{ marginTop: 8, borderTop: "1px dashed #e5e7eb", paddingTop: 6 }}
         onClick={(e) => e.stopPropagation()}>
      <div style={{ fontSize: 12, fontWeight: 600, color: "#334155", marginBottom: 4 }}>
        Shop drawings{areaName ? ` in ${areaName}` : ""}
        {!state.loading && !state.error ? <span style={{ fontWeight: 400, color: "#94a3b8" }}> · {state.rows.length}</span> : null}
      </div>
      {state.loading ? <Spin size="small" /> : null}
      {state.error ? (
        <div style={{ color: "#B84B0A", fontSize: 12 }}>Could not read the shop drawings ({state.error})</div>
      ) : null}
      {!state.loading && !state.error && !state.rows.length ? (
        <div style={{ color: "#94a3b8", fontSize: 12 }}>
          No shop drawing is filed under this area. A drawing lands here from the schedule activity it hangs off.
        </div>
      ) : null}
      {state.rows.map((r) => {
        const [word, colour] = STATUS[r.status] || [r.status, "default"];
        return (
          <div key={r._id} style={{ marginBottom: 6 }}>
            <div style={{ display: "flex", gap: 6, alignItems: "baseline" }}>
              <a href={`/shop-drawings/${projectId}?drawing=${r._id}`} target="_blank" rel="noopener noreferrer"
                 style={{ flex: 1, fontSize: 12.5, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                 title={r.name}>
                {r.sheetNumber ? <b>{r.sheetNumber} </b> : null}{r.name}
              </a>
              <Tag color={colour} style={{ marginRight: 0, fontSize: 11 }}>{word}</Tag>
            </div>
            <ActivityPathLine activity={{ activityFullPath: r.activityFullPath, name: r.scheduleName }}
                              missing={!!r.scheduleMissing} />
          </div>
        );
      })}
    </div>
  );
}
